import React from "react";
import { DocumentAttachment } from "@customTypes/responses/document";
import { fetchDownloadUrl } from "@services/documents";
import { AttachmentLinkButton } from "./style";
import { Tooltip } from "nectar-ui";

type AttachmentItemProps = {
  attachment: DocumentAttachment;
};

const AttachmentItem: React.FC<AttachmentItemProps> = ({ attachment }) => {
  const handleDownload = async () => {
    const urlResponse = await fetchDownloadUrl({
      fileName: attachment.fileName,
      gsObjectName: attachment.objectName,
    });

    const invisibleLink = document.createElement("a");
    invisibleLink.href = urlResponse.urlDownload;

    invisibleLink.setAttribute("target", "_blank");
    invisibleLink.click();
    invisibleLink.remove();
  };

  return (
    <Tooltip title="Visualizar" isVisible placement="top" preventOverflow>
      <AttachmentLinkButton link onClick={handleDownload}>
        {attachment.fileName}
      </AttachmentLinkButton>
    </Tooltip>
  );
};

export default AttachmentItem;
